import React from 'react';
import { useSelector } from 'react-redux';
import { getImageFilepath, formatParagraphs, getBackground } from '../../../models/Utils';
import { useWindowSize } from '../../../models/Hooks';

import './QuoteStory.scss';
import { ADAARIARoles, ADALandmarks } from '../../../models/ADA';

const QuoteStory = ({ cardData, isInline }) => {
  const window = useWindowSize();
  const configData = useSelector(state => state.config);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const lines = cardData.QuoteAttribution && cardData.QuoteAttribution.split(',');
  const author = (lines[0] || '').trim();
  const position = (lines[1] || '').trim();
  const company = (lines[2] || '').trim();

  const cardBackground = getBackground(cardData);

  var classname = 'quote-story'  + (cardData.className || '' + isInline ? " inline" : "");

  return (
    <div className={classname} >
      <div
        className="img-holder"
        role="img"
        alt={cardBackground.AltText}
        style={
          cardBackground && cardBackground.Image
            ? {
                backgroundImage: `url("${
                  configData.basePath +
                  configData.apiMediaPath +
                  getImageFilepath(cardBackground.Image)
                }")`,
              }
            : {}
        }
      >
        {cardBackground.Overlay ? (
          <div
            className="overlay"
            style={{
              backgroundColor: cardBackground.Overlay,
              opacity: cardBackground.Opacity,
            }}
          ></div>
        ) : null}
        <div className="content">
          <div className="width-wrapper">
            <div className="content-wrapper">
              <q>{formatParagraphs(cardData.Body)}</q>
              <p className="author">
                {author && (
                  <span>
                    {author}
                    {company || position ? ',' : ''}
                  </span>
                )}
                {company && (
                  <span>
                    {company}
                    {position ? ',' : ''}
                  </span>
                )}
                {position && <span>{position}</span>}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteStory;
